var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 787.5c-247.73-7.8359-247.8-367.12 0-375 247.73 7.8359 247.8 367.12 0 375zm498-111.07c-90.75 112.12-276.11 300.23-498 300.23-221.89-0.003906-407.25-188.1-497.96-300.23-17.402-21.672-26.887-48.633-26.887-76.426s9.4844-54.754 26.887-76.426c319.12-396.79 676.35-397.24 995.96 0 17.375 21.684 26.844 48.641 26.844 76.426s-9.4688 54.742-26.844 76.426zm-235.5-76.426c-12.301-347.32-512.66-347.44-525 0 0 69.621 27.656 136.39 76.883 185.62 49.23 49.227 116 76.883 185.62 76.883s136.39-27.656 185.62-76.883c49.227-49.23 76.883-116 76.883-185.62z",
    fill: "#1c9bf1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemCount);
export default __webpack_public_path__ + "static/media/item-count.1dcc9fa85a7e46f7c67b66e6c3ed13cf.svg";
export { ForwardRef as ReactComponent };